import { createContext, useContext, useMemo } from 'react';
import { useDashboardContext } from '../DashboardContext';
import { ModuleData } from '../Types';

let count = 0;
let start = 0;
const eventDuration = 3000;

export const rnd = (num: number) => Math.round(Math.random() * num);

const getTime = () => {
    if (!start) start = Date.now();
    return Date.now() - start;
};

const getAuths = (number: number, duration: number) =>
    new Array(number)
        .fill(null)
        .map(() => ({
            begin: getTime() + rnd(duration - eventDuration),
            y: rnd(40) + 30,
            id: count++,
            duration: eventDuration
        }));

interface ModulesContext {
    modulesArray: (ModuleData & { key: string })[];
    events: ReturnType<typeof getAuths>;
}

export const ModuleContext = createContext<ModulesContext>({
    modulesArray: [],
    events: []
});

export const ModuleContextProvider: React.FC = ({ children }) => {
    const { modules, auths } = useDashboardContext();

    const modulesArray = useMemo(
        () =>
            Object.entries(modules)
                .reverse()
                .map(([key, m]) => ({ ...m, key })),
        [modules]
    );

    const events = useMemo(() => getAuths(auths.auths, auths.duration), [auths]);

    return (
        <ModuleContext.Provider
            value={{
                modulesArray,
                events
            }}>
            {children}
        </ModuleContext.Provider>
    );
};

export const useModulesContext = () => useContext(ModuleContext);
